export default function developerAuth({next, auth}){
    const adminRoles = ['super-admin', 'developer']

        if(! adminRoles.includes(auth.role)) {
            return next({
                name: '403'
            });
        }

    return next();
}